import { WithdrawForm } from 'pages/Wallets/components/Withdraw/Withdraw'
import { WalletType } from 'types/types'
import { PayoutInstructionTypes, PayoutRequest } from 'types/unifiedPayouts/unifiedPayouts'

export const getWithdrawRequest = (
  formValues: WithdrawForm,
  selectedWallet: WalletType,
  isPayoutsV2Enabled: boolean
): PayoutRequest => {
  return {
    walletId: isPayoutsV2Enabled ? selectedWallet?.lsid : selectedWallet?.id?.toString(),
    amount: {
      value: formValues?.amount,
      currency: selectedWallet?.currency?.code,
    },
    paymentReference: formValues?.reference,
    instruction: {
      type: PayoutInstructionTypes.FIAT,
      beneficiary: {
        reference: formValues?.bankAccountId,
      },
    },
  }
}
